import { List, Text } from "react-native-paper";
import { type AppTheme, useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import DonutChart from "../DonutChart";

export type ActivityLogItem = {
	title: string;
	subtitle: string;
	score?: number;
	earned?: boolean;
	distribution: number[];
};

type Props = {
	item: ActivityLogItem;
	onPress: () => void;
	disabled?: boolean;
};

const getEarnedIcon = (
	item: ActivityLogItem,
	theme: AppTheme,
	disabled?: boolean,
) => (
	<Box
		width={40}
		height={40}
		borderRadius={20}
		backgroundColor={theme.colors.primaryContainer}
		justifyContent="center"
		alignItems="center"
	>
		<Text
			variant="labelLarge"
			style={{ color: theme.colors.onPrimaryContainer }}
		>
			{disabled ? "-" : `+${item.score || 1}`}
		</Text>
	</Box>
);

export const ActivityLogListItem = ({ item, onPress, disabled }: Props) => {
	const theme = useAppTheme();

	return (
		<List.Item
			title={<Text variant="bodyMedium">{item.title}</Text>}
			description={<Text variant="bodySmall">{item.subtitle}</Text>}
			onPress={onPress}
			disabled={disabled}
			right={(p) =>
				disabled ? null : (
					<List.Icon {...p} icon="eye-outline" color={theme.colors.primary} />
				)
			}
			left={(p) => (
				<List.Icon
					{...p}
					icon={() =>
						item.earned ? (
							getEarnedIcon(item, theme, disabled)
						) : (
							<DonutChart
								distribution={item.distribution}
								radius={20}
								innerRadius={16}
								variant="progress"
							>
								<Text variant="labelSmall">{item.score}%</Text>
							</DonutChart>
						)
					}
				/>
			)}
		/>
	);
};
